module.exports = __webpack_public_path__ + "static/img/jtsl-title.12ea8cd9.png";